import PropTypes from 'prop-types';
import React, {Component} from 'react';

//styles
import {Tag, TagName, StyledIcon} from './styles';

class TagComponent extends Component {
  static defaultProps = {
    iconSize: 12
  };

  static propTypes = {
    iconName: PropTypes.string,
    iconSize: PropTypes.number,
    onIconClick: PropTypes.func
  };

  render() {
    const {tagName, iconName, iconSize, onIconClick, ...forwardedProps} = this.props;

    return (
      <Tag {...forwardedProps}>
        {tagName && <TagName>{tagName}</TagName>}
        {iconName && <StyledIcon name={iconName} size={iconSize} onClick={onIconClick} />}
      </Tag>
    );
  }
}

export default TagComponent;
